const ColdChain = () => {
  return (
    <div>
      <div className="">
        <img src="/logisticsBanner/banner-10.jpg" width="100%"/>
      </div>

      <div className="flex flex-col justify-center items-center mb-[1.5rem]">
        <hr className="w-[52rem]"/>
        <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
        
          <div className="flex flex-col justify-center">
            <h1 className="font-bold text-3xl text-[#373737]">
              Cold Chain Management
            </h1>
            <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              With our extensive network, global infrastructure and the best storage and transportation facilities, 
              you can be sure that your temperature-sensitive cargo is handled, managed and stored at the right 
              temperature along a supply chain. 
            </p>
            <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              Every link in the cold chain represents the potential for problems. We understand the need for full control 
              throughout the journey and assess risk and risk mitigation for all transport lanes for a smoother, more 
              secure process.
            </p>
            <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              Due to having our own warehouses and, one of the largest company-owned fleet in Pakistan and a perfect 
              Fleet Integrated Management System, we are able to have full control of cold chain logistics—from origin 
              to destination, including Temperature controlled transport and Storage, Distribution, LTL & FTL services, 
              Door to Door services, Live Track & Trace through data loggers
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
          </div>
        </div>
      
      </div>
    </div>

  )
};
export default ColdChain;